module.exports = __webpack_public_path__ + "img/time.21814d2.png";